import { GTM_GLOBAL } from '@/constants/gtm'

export default function ({ app: { $gtm, context } }) {
  window.addEventListener('beforeunload', function() {
    if (context?.route?.query?.bigModal === 'registration') {
      $gtm.push({ event: GTM_GLOBAL.EVENT.ga_registration_interrupted })
    }
  })
}
